<template>
    <figure v-lazyload :class="'image load--' + position + (imageClass ? ' ' + imageClass : '')" class="image">
        <img
            class="image__item"
            :data-url="source"
            :data-mood-url="moodUrl"
            :alt="alt"
            :width="imageWidth ? imageWidth : ''"
            :height="imageHeight ? imageHeight : ''"
        >

        <div v-if="outofStock" class="out-of-stock">
            <span v-if="outofStockMessage">{{outofStockMessage}}</span>
            <span v-else>Out of Stock</span>
        </div>

        <div v-if="pinData || allowFav" class="buttons__wrap">
            <div v-if="pinData" class="pin-button__wrap">
                <PinButton
                    :imageURL="pinData.image"
                    :imageDescription="pinData.imageTitle"
                ></PinButton>
            </div> 
            
            <div v-if="allowFav" class="fav-wrapper">
                <FavButton :imageID="imageID"></FavButton>
            </div>
        </div>
    </figure>
</template>

<script>
    import PinButton from "../../components/PinButton/PinButton";
    import FavButton from "../FavButton/FavButon";

    export default {
        name: "image-item",
        components: {
            PinButton,
            FavButton,
        },
        props: {
            pinData: {
                type: Object
            },
            source: {
                type: String,
                required: true
            },
            imageWidth: {
                type: Number,
                required: false
            },
            imageHeight: {
                type: Number,
                required: false
            },
            alt: {
                type: String,
                required: false
            },
            position: {
                type: String,
                required: true
            },
            moodUrl: {
                type: String
            },
            outofStock: {
                type: Boolean,
                required: false
            },
            outofStockMessage: {
                type: String
            },
            allowFav: {
                type: Boolean
            },
            imageID: {
                type: Number
            },
            imageClass: {
                type: String,
                required: false
            },
        }
    };
</script>

<style scoped lang="scss">
    figure.image {
        display: block !important;
    }

    .image {
        margin: 0;
        padding: 0;

        img {
            width: 100%;
            height: auto;
        }

        &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: 3;
            transition: all 0.6s ease;
            transform: scaleX(1);
            background: #f9f9f9;
            //mix-blend-mode: color;
        }

        &.load--right {
            &.loaded:before {
                width: 0;
                //transform: scaleX(0);
            }
        }

        &.load--top {
            &.loaded:before {
                height: 0;
                //transform: scaleX(0);
            }
        }

            .out-of-stock {
                position: absolute;
                z-index: 10;
                background-color: #fff;
                cursor: pointer;
                // width: 15px;
                width: 100%;
                min-height: 25px;
                top: 45%;
                // right: 1rem;
                // background-position: center;
                // background-repeat: no-repeat;
                // background-size: 20px;
                // background-image: url('#{$dir-images}icons/close-white.svg');
                transition: all 300ms;
                text-align: center;
            }
    }

    .ratio--53-35 img {
        aspect-ratio: 53 / 35;
    }
    
    .object-cover img {
        object-fit: cover;
    }
</style>